import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';
import { CustomLoader } from '../../../custom-loader';

export const AuditContentView = ({ auditData, isAuditDataLoading }) => {
	if (isAuditDataLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="audit-content">
			<>
				{auditData ? (
					<div className="audit-content__table" dangerouslySetInnerHTML={{ __html: auditData }} />
				) : (
					<div className="audit-content__empty-message">Изменения не найдены</div>
				)}
			</>
		</div>
	);
};

AuditContentView.propTypes = {
	auditData: PropTypes.string,
	isAuditDataLoading: PropTypes.bool.isRequired,
};
